import React from "react";
import logo from "../assets/img/logo.png";
import "./Footer.css";

export default function Footer() {
  return (
    <>
       <div class="copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6 m-auto">
          <span>© 2022 BizConnect.Events. All rights reserved.</span>
        </div>
        <div class="col-md-6">
          <div class="copyright-menu">
            <ul>
              <li>
                <a href="#">Powered by BizConnect</a>
              </li>
              <li>
                <img className="copyright-logo" src={logo} alt="BizConnect"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
  );
}
